<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  //Element繁体中文
//  ELEMENT.locale(ELEMENT.lang.zhTW);
  export default {
    name: 'App',
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return{
        isRouterAlive:true, //刷新
      }
    },
    methods:{
      //刷新
      reload(){
        this.isRouterAlive=false;
        this.$nextTick(function () {
          this.isRouterAlive=true;
        })
      },
    },
    mounted(){
      this.$nextTick(function () {
        document.getElementById("loads").style.display="none";
      });
    },
  }
</script>

<style>
  #app{
    height: 100%;
  }
  /*::-webkit-scrollbar {*/
    /*display: none;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue